var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MetaMask"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 71",
    width: 96,
    height: 96,
    rx: 10,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MetaMask_Fox 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.5055 19.3875L51.2124 36.6875L55.5199 26.4807L74.5055 19.3875Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7325 19.3875L43.8383 36.8514L39.7415 26.4807L20.7325 19.3875ZM66.1247 59.489L59.921 68.9935L73.1945 72.6455L77.0104 59.6997L66.1247 59.489ZM18.2744 59.6997L22.0669 72.6455L35.3404 68.9935L29.1367 59.489L18.2744 59.6997Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.5913 43.4297L30.8925 49.0247L44.0723 49.6099L43.6041 35.4468L34.5913 43.4297ZM60.6467 43.4297L51.5168 35.283L51.2124 49.6099L64.3689 49.0247L60.6467 43.4297ZM35.3404 68.9935L43.253 65.1308L36.4172 59.7933L35.3404 68.9935ZM51.985 65.1308L59.921 68.9935L58.8207 59.7933L51.985 65.1308Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.9209 68.9935L51.9849 65.1309L52.617 70.3045L52.5468 72.4816L59.9209 68.9935ZM35.3403 68.9935L42.7145 72.4816L42.6677 70.3045L43.2529 65.1309L35.3403 68.9935Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.8316 56.3754L36.23 54.4323L40.8886 52.302L42.8316 56.3754ZM52.4064 56.3754L54.3494 52.302L59.0314 54.4323L52.4064 56.3754Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.3404 68.9935L36.4641 59.489L29.1367 59.6997L35.3404 68.9935ZM58.7973 59.489L59.921 68.9935L66.1247 59.6997L58.7973 59.489ZM64.3689 49.0247L51.2125 49.6099L52.4298 56.3754L54.3728 52.3021L59.0548 54.4324L64.3689 49.0247ZM36.23 54.4324L40.912 52.3021L42.8316 56.3754L44.0724 49.6099L30.8925 49.0247L36.23 54.4324Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.8925 49.0247L36.4172 59.7933L36.23 54.4324L30.8925 49.0247ZM59.0548 54.4324L58.8207 59.7933L64.3689 49.0247L59.0548 54.4324ZM44.0723 49.6099L42.8316 56.3754L44.3767 64.3583L44.7278 53.8471L44.0723 49.6099ZM51.2124 49.6099L50.5804 53.8237L50.8613 64.3583L52.4298 56.3754L51.2124 49.6099Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52.4298 56.3754L50.8613 64.3583L51.985 65.1308L58.8207 59.7933L59.0548 54.4324L52.4298 56.3754ZM36.23 54.4324L36.4173 59.7933L43.253 65.1308L44.3767 64.3583L42.8316 56.3754L36.23 54.4324Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.5468 72.4815L52.617 70.3044L52.0317 69.7894H43.2061L42.6677 70.3044L42.7145 72.4815L35.3403 68.9934L37.9154 71.1003L43.1359 74.7289H52.102L57.3458 71.1003L59.9209 68.9934L52.5468 72.4815Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.9849 65.1309L50.8613 64.3584H44.3767L43.253 65.1309L42.6677 70.3046L43.2062 69.7895H52.0318L52.617 70.3046L51.9849 65.1309Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M75.4888 37.8112L77.4786 28.2599L74.5055 19.3875L51.985 36.1023L60.6467 43.4296L72.8902 47.0114L75.6058 43.851L74.4353 43.0083L76.3081 41.2993L74.8567 40.1756L76.7295 38.7476L75.4888 37.8112ZM17.7828 28.2599L19.7727 37.8112L18.5086 38.7476L20.3814 40.1756L18.9533 41.2993L20.8262 43.0083L19.6556 43.851L22.3478 47.0114L34.5913 43.4296L43.253 36.1023L20.7325 19.3875L17.7828 28.2599Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M72.8902 47.0114L60.6467 43.4296L64.3689 49.0246L58.8207 59.7933L66.1247 59.6997H77.0104L72.8902 47.0114ZM34.5913 43.4296L22.3478 47.0114L18.2744 59.6997H29.1367L36.4172 59.7933L30.8925 49.0246L34.5913 43.4296ZM51.2124 49.6099L51.985 36.1023L55.5433 26.4807H39.7415L43.253 36.1023L44.0724 49.6099L44.3533 53.8705L44.3767 64.3583H50.8613L50.9081 53.8705L51.2124 49.6099Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.8699b0120c9c3d4f29962bd30ff9ef07.svg";
export { ForwardRef as ReactComponent };